<template>
  <v-card height="100%">
    <project-flow-navigation-toolbar
      :title="masterplanName"
    ></project-flow-navigation-toolbar>
    <v-toolbar dense>
      <v-tabs v-model="tab">
        <v-tab href="#details"> Details </v-tab>
        <v-tab href="#media"> Media </v-tab>
        <v-tab href="#pois"> Points of interest </v-tab>

        <v-tab v-if="!isCommunity" href="#masterplans">
          Masterplans
        </v-tab>
        <v-tab v-if="!isCommunity" href="#community">
          Community
        </v-tab>
        <v-tab href="#buildings"> Buildings </v-tab>
        <v-tab v-if="isParcelProject" href="#parcels"> Parcels </v-tab>
      </v-tabs>
    </v-toolbar>
    <v-tabs-items v-model="tab">
      <v-tab-item value="details">
        <v-card>
          <v-card-text>
            <v-row>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  class="mt-5"
                  dense
                  :key="masterplan.id"
                  v-model="masterplan.name"
                  label="Name"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6" md="4">
                <v-select
                  :items="communities"
                  class="mt-5"
                  dense
                  :key="masterplan.community"
                  v-model="masterplan.community"
                  label="community"
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  class="mt-5"
                  dense
                  v-model="masterplan.parentId"
                  label="Parent Id"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6" md="4">
                <v-card-title style="margin-left: -12px">
                  ParentId should be configured by developers only!
                </v-card-title>
              </v-col>
            </v-row>
          </v-card-text>
          <v-row class="ml-1 mb-1">
            <v-card-title>
              <div class="pr-2" v-if="getMasterplanTabTitle !== null">
                Masterplan is:
              </div>
              <div class="pr-2" v-else>Community is:</div>
              {{ `${masterplan.publish ? 'published' : 'unpublished'}` }}
            </v-card-title>
            <v-card-text>
              <v-switch
                v-if="dialogButton('active')"
                inset
                hide-details="auto"
                class="mt-0 ml-1"
                v-model="masterplan.publish"
              >
              </v-switch>
              <div class="text-center" v-if="dialogButton('deactive')">
                <v-dialog v-model="dialog" width="500">
                  <template v-slot:activator="{ on }">
                    <v-switch
                      v-on="on"
                      inset
                      hide-details="auto"
                      class="mt-0 ml-1 checkboxButton"
                      v-model="masterplan.publish"
                      disabled
                    >
                    </v-switch>
                  </template>

                  <v-card>
                    <v-card-title class="text-h5 lighten-2">
                      Publish Masterplan
                    </v-card-title>

                    <v-card-text>
                      The action is not possible because there is more than one
                      community/building visible inside this
                      masterplan/community.
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" text @click="dialog = false">
                        Ok
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </div>
            </v-card-text>
          </v-row>
          <v-row class="ml-1 mb-1">
            <v-card-title class="pa-0 ml-3"
              >Fall-through navigation</v-card-title
            >
          </v-row>
          <v-row class="ml-1">
            <v-col cols="12">
              <p class="mb-2">
                Enable to send visitors who land on this masterplan straight to
                one of its own child masterplans or buildings, instead of
                stopping here. Chains with a project-level fall-through: if the
                project falls through to this masterplan and this is enabled,
                navigation continues on to the target below.
              </p>
              <v-switch
                v-model="fallThroughEnabled"
                label="Fall through to a child masterplan/building"
                hide-details="auto"
              ></v-switch>
            </v-col>
          </v-row>
          <v-row v-if="fallThroughEnabled" class="ml-1">
            <v-col cols="12" sm="6" md="4">
              <v-select
                :items="fallThroughMasterplanOptions"
                item-text="name"
                item-value="id"
                label="Child masterplan (optional)"
                outlined
                dense
                clearable
                v-model="fallThroughMasterplanId"
                hide-details="auto"
              >
                <template v-slot:item="{ item, on, attrs }">
                  <v-list-item v-bind="attrs" v-on="on">
                    <v-list-item-title
                      :style="{ paddingLeft: item.depth * 20 + 'px' }"
                    >
                      <span v-if="item.depth > 0" class="grey--text mr-1"
                        >&#8627;</span
                      >{{ item.name }}
                    </v-list-item-title>
                  </v-list-item>
                </template>
                <template v-slot:selection="{ item }">
                  {{ item.name }}
                </template>
              </v-select>
            </v-col>
            <v-col v-if="!isParcelProject" cols="12" sm="6" md="4">
              <v-select
                :items="fallThroughBuildingOptions"
                item-text="name"
                item-value="id"
                :label="
                  fallThroughMasterplanId
                    ? 'Building under that masterplan (optional)'
                    : 'Building under this masterplan (optional)'
                "
                outlined
                dense
                clearable
                v-model="fallThroughBuildingId"
                hide-details="auto"
              ></v-select>
            </v-col>
          </v-row>
          <v-spacer />
          <v-card-actions>
            <v-btn color="red darken-1" @click="deleteMasterplan">Delete</v-btn>
            <v-spacer></v-spacer>
            <v-fade-transition>
              <span
                v-if="changeDetected"
                class="caption amber--text d-flex align-center mr-2"
              >
                <v-icon x-small color="amber" class="mr-1"
                  >mdi-circle-medium</v-icon
                >Unsaved changes
              </span>
            </v-fade-transition>
            <v-btn v-if="changeDetected" text @click="discard">Discard</v-btn>
            <v-btn
              color="blue darken-1"
              :disabled="saveButtonDisabled"
              @click="save"
              >Save</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-tab-item>
      <v-tab-item value="media">
        <media
          v-if="showMedia"
          ref="media"
          :media="this.$store.state.MediaStore.media"
          :is-visible="tab === 'media'"
        ></media>
        <v-card-subtitle v-if="!showMedia"
          >There is no default poi for this record, media is not available.
        </v-card-subtitle>
      </v-tab-item>
      <v-tab-item value="pois">
        <v-list-item>
          <v-list-item-content>
            <poi-list
              :poi-list="this.$store.state.PoiStore.pois"
              parentType="masterplan"
              :parent="this.$store.state.MasterplanStore.selectedMasterplan"
            ></poi-list>
          </v-list-item-content>
        </v-list-item>
      </v-tab-item>
      <v-tab-item value="masterplans">
        <v-card flat>
          <v-card-text class="pa-0">
            <v-list-item>
              <v-list-item-content>
                <masterplan-list
                  :masterplanList="
                    this.$store.state.MasterplanStore
                      .selectedMasterplansNestedMasterplans
                  "
                  :context="'masterplan'"
                ></masterplan-list>
              </v-list-item-content>
            </v-list-item>
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item value="community">
        <v-card flat>
          <v-card-text class="pa-0">
            <v-list-item>
              <v-list-item-content>
                <masterplan-list
                  :masterplanList="
                    this.$store.state.MasterplanStore
                      .selectedMasterplansNestedMasterplansCommunities
                  "
                  :context="'community'"
                ></masterplan-list>
              </v-list-item-content>
            </v-list-item>
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item value="buildings">
        <v-list-item>
          <v-list-item-content>
            <building-list
              :buildingList="this.$store.state.BuildingStore.buildings"
            ></building-list>
          </v-list-item-content>
        </v-list-item>
      </v-tab-item>
      <v-tab-item v-if="isParcelProject" value="parcels">
        <v-list-item>
          <v-list-item-content>
            <parcel-list
              :parcelList="this.$store.state.ParcelStore.parcels"
            ></parcel-list>
          </v-list-item-content>
        </v-list-item>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
import MasterplanList from '../../components/RecordLists/MasterplanList'
import BuildingList from '../../components/RecordLists/BuildingList'
import ParcelList from '../../components/RecordLists/ParcelList'
import ProjectFlowNavigationToolbar from '../../components/AppBar/ProjectFlowNavigationToolbar'
import Enums from '../../helpers/Enums'
import Media from '../../views/Media'
import PoiList from '../../components/RecordLists/PoiList'
import { mapState } from 'vuex'
import MasterplanService from '../../services/MasterplanService'
import licensingEngine from '../../services/licensingEngine'
import MasterplanHelper from '../../helpers/MasterplanHelper'
import { MediaGalleryLeaveGuardMixin } from '../../mixins/MediaGalleryLeaveGuardMixin'

export default {
  name: 'MasterplanExpore',
  mixins: [MediaGalleryLeaveGuardMixin],
  props: {},
  components: {
    BuildingList,
    ParcelList,
    MasterplanList,
    ProjectFlowNavigationToolbar,
    PoiList,
    Media
  },
  data: function() {
    return {
      pois: [],
      dialog: false,
      buildings: [],
      masterplan: {},
      // Snapshot taken right after hydrateMasterplan() normalizes
      // `masterplan` (fills in properties.fallThrough on older rows that
      // never had it). Diffing against this instead of the raw
      // selectedMasterplan avoids that normalization itself being mistaken
      // for an unsaved change — see hydrateMasterplan.
      originalMasterplan: {},
      title: '',
      tab: 'details',
      media: [],
      communities: [true, false],
      showMedia: false,
      changeDetected: false,
      checkboxDisabled: false,
      licenses: [],
      isDisabled: true,
      isCommunity: false,
      // Buildings for whichever masterplan the fall-through picker's own
      // masterplan select currently targets (only fetched when that's set —
      // otherwise the fall-through building picker uses this masterplan's
      // own already-loaded BuildingStore list).
      fallThroughBuildingOptionsList: []
    }
  },
  computed: {
    getMasterplanTabTitle() {
      if (this.$store.state.MasterplanStore.selectedMasterplan) {
        if (this.$store.state.MasterplanStore.selectedMasterplan.community) {
          return 'COMMUNITY'
        } else {
          return 'MASTERPLANS'
        }
      } else {
        return 'MASTERPLANS'
      }
    },
    masterplanName: function() {
      return this.$store.state.MasterplanStore.selectedMasterplan
        ? this.$store.state.MasterplanStore.selectedMasterplan.name
        : ''
    },
    ...mapState('MediaStore', ['selectedGallery']),
    saveButtonDisabled: function() {
      return !this.changeDetected
    },
    isParcelProject: function() {
      const project = this.$store.state.ProjectStore.selectedProject
      return !!(project && project.isParcelProject)
    },
    // Fall-through navigation for THIS masterplan — same shape as the
    // project-level setting (project.properties.fallThrough) but scoped to
    // this masterplan's own subtree. Chains: if a project falls through to
    // this masterplan and this is also enabled, the frontend continues on
    // to this masterplan's own target instead of stopping here.
    fallThroughEnabled: {
      get() {
        return !!(
          this.masterplan.properties &&
          this.masterplan.properties.fallThrough &&
          this.masterplan.properties.fallThrough.enabled
        )
      },
      set(val) {
        this.masterplan.properties.fallThrough.enabled = val
        if (!val) {
          this.masterplan.properties.fallThrough.masterplanId = null
          this.masterplan.properties.fallThrough.buildingId = null
        }
      }
    },
    fallThroughMasterplanId: {
      get() {
        return (
          (this.masterplan.properties &&
            this.masterplan.properties.fallThrough &&
            this.masterplan.properties.fallThrough.masterplanId) ||
          null
        )
      },
      set(val) {
        this.masterplan.properties.fallThrough.masterplanId = val
        this.masterplan.properties.fallThrough.buildingId = null
        this.fallThroughBuildingOptionsList = []
        if (val) {
          this.loadFallThroughBuildingOptions(val)
        }
      }
    },
    fallThroughBuildingId: {
      get() {
        return (
          (this.masterplan.properties &&
            this.masterplan.properties.fallThrough &&
            this.masterplan.properties.fallThrough.buildingId) ||
          null
        )
      },
      set(val) {
        this.masterplan.properties.fallThrough.buildingId = val
      }
    },
    // Scoped to this masterplan's own descendants (not the whole project) —
    // a masterplan can only fall through further down its own subtree.
    fallThroughMasterplanOptions() {
      const all = this.$store.state.MasterplanStore.projectMasterplans || []
      return MasterplanHelper.buildMasterplanTreeOptions(
        all,
        this.masterplan.id
      )
    },
    // No target masterplan chosen means "fall through straight to one of my
    // OWN buildings", so this falls back to BuildingStore's already-loaded
    // list for the current masterplan rather than a separate fetch.
    fallThroughBuildingOptions() {
      return this.fallThroughMasterplanId
        ? this.fallThroughBuildingOptionsList
        : this.$store.state.BuildingStore.buildings
    }
  },
  watch: {
    selectedGallery: async function(newValue) {
      await this.$store.dispatch('MediaStore/fetchMedia')
    },
    '$store.state.MasterplanStore.selectedMasterplan'() {
      return (this.isCommunity = this.$store.state.MasterplanStore.selectedMasterplan.community)
    },
    masterplan: {
      // This will let Vue know to look inside the object
      deep: true,
      handler: function(after, before) {
        if (JSON.stringify(before) !== '{}') {
          this.changeDetected =
            JSON.stringify(this.masterplan) !==
            JSON.stringify(this.originalMasterplan)
        }
      }
    },
    tab: async function(newValue, oldValue) {
      // if (newValue === 'media') {
      //   await this.$store.dispatch('MediaStore/resetStore')
      //   await this.$store.dispatch('MediaStore/setMediaContext', 'poi')
      // }
      this.guardMediaTabSwitch(newValue, oldValue, 'media')
    }
  },

  methods: {
    dialogButton(status) {
      let nestedMasterplans = this.$store.state.MasterplanStore
        .selectedMasterplansNestedMasterplans
      nestedMasterplans = nestedMasterplans.filter(el => el.publish === true)
      if (nestedMasterplans && nestedMasterplans.length > 0) {
        if (nestedMasterplans.length > 1) {
          return status === 'active' ? false : true
        } else {
          return status === 'active' ? true : false
        }
      } else {
        let buildings = this.$store.state.BuildingStore.buildings
        buildings = buildings.filter(el => el.publish === true)
        if (buildings.length > 1) {
          return status === 'active' ? false : true
        } else {
          return status === 'active' ? true : false
        }
      }
    },
    //checking if license is configured in licensing engine and enables/disables nestedmasterplans accordingly
    async nestedMasterplansLicenseDisabled() {
      await licensingEngine().then(res => (this.licenses = res.data))
      if (this.licenses.licenses.length > 0) {
        this.isDisabled = false
      }
    },
    async loadFallThroughBuildingOptions(masterplanId) {
      const res = await MasterplanService.getBuildingsForMasterplan(
        masterplanId
      )
      this.fallThroughBuildingOptionsList = res.data || []
    },
    // Reassigns `masterplan` from the (freshly fetched) selectedMasterplan
    // and makes sure properties.fallThrough exists as its own reactive key
    // — Vue 2 can't track a plain `obj.enabled = x` assignment on a key
    // that wasn't there yet (e.g. a masterplan saved before this field
    // existed), which would silently break both the fall-through inputs
    // and the changeDetected deep watcher above.
    hydrateMasterplan() {
      this.masterplan = JSON.parse(
        JSON.stringify(this.$store.state.MasterplanStore.selectedMasterplan)
      )
      if (!this.masterplan.properties)
        this.$set(this.masterplan, 'properties', {})
      if (!this.masterplan.properties.fallThrough) {
        this.$set(this.masterplan.properties, 'fallThrough', {
          enabled: false,
          masterplanId: null,
          buildingId: null
        })
      }
      this.originalMasterplan = JSON.parse(JSON.stringify(this.masterplan))
      if (this.masterplan.properties.fallThrough.masterplanId) {
        this.loadFallThroughBuildingOptions(
          this.masterplan.properties.fallThrough.masterplanId
        )
      }
    },
    getData: async function(masterplanId) {
      if (masterplanId) {
        await this.$store.dispatch('MediaStore/resetStore')
        await this.$store.dispatch(
          'MasterplanStore/setSelectedMasterplan',
          parseInt(masterplanId),
          {
            root: true
          }
        )
        await this.$store.dispatch('MasterplanStore/fetchMasterplans')
        await this.$store.dispatch('BuildingStore/fetchBuildings')
        if (this.isParcelProject) {
          await this.$store.dispatch('ParcelStore/fetchParcels')
        }
        await this.$store.dispatch('PoiStore/setPoiContext', 'masterplan')
        await this.$store.dispatch('PoiStore/fetchPois')

        this.hydrateMasterplan()
        if (this.masterplan.parentId > 0) {
          const parentMasterplan = await MasterplanService.getMasterplanById(
            this.masterplan.parentId
          )
          if (!parentMasterplan.data.publish) {
            this.checkboxDisabled = true
          }
        }
        // find default poi
        let defaultPoi = this.$store.state.PoiStore.pois.find(el => {
          return el.poiTypeId === Enums.PoiType.poi_type_masterplan
        })
        if (defaultPoi) {
          await this.$store.dispatch('MediaStore/resetStore')
          await this.$store.dispatch('PoiStore/setSelectedPoi', defaultPoi.id)
          await this.$store.dispatch('MediaStore/setMediaContext', 'poi')

          // await this.$store.dispatch('MediaStore/fetchMediaTypes')
          // await this.$store.dispatch('MediaStore/fetchMedia')
          this.showMedia = true
        } else {
          this.showMedia = false
        }

        //this.media = this.$store.state.MediaStore.media
        // await this.$store.dispatch('MediaStore/setMediaContext', "poi")
        //       await this.$store.dispatch('MediaStore/fetchMedia')
        //       this.media = this.$store.state.MediaStore.Media
      }
    },
    save: async function() {
      await this.$store.dispatch(
        'MasterplanStore/updateMasterplan',
        this.masterplan
      )
      // Updateovanje masterplana se sada izvrsava u updateMasterplan akciji:
      // await this.$store.dispatch(
      //   'MasterplanStore/setSelectedMasterplan',
      //   this.$route.params.masterplanId
      // )
      this.hydrateMasterplan()
      this.changeDetected = false
    },
    deleteMasterplan: async function() {
      this.$confirm({
        title: 'Delete Masterplan',
        text: 'Are you sure?',
        acceptText: 'DELETE',
        cancelText: 'CANCEL'
      })
        .then(y => {
          this.$store
            .dispatch(
              'MasterplanStore/deleteMasterplan',
              this.$route.params.masterplanId
            )
            .then(
              () => {
                this.$router.go(-1)
                this.$emit('deleted')
              },
              err => {
                this.$store.dispatch(
                  'NotificationStore/add',
                  {
                    type: 'error',
                    message:
                      'Masterplan has child records, it cannot be deleted.'
                  },
                  { root: true }
                )
              }
            )
        })
        .catch(n => {})
    },
    discard() {
      this.hydrateMasterplan()
      this.changeDetected = false
    }
  },
  created: function() {
    // if (localStorage.exploreMasterplanActiveTabs) {
    //   let temp = JSON.parse(localStorage.exploreMasterplanActiveTabs)
    //   let item = temp.find(
    //     element => element.mid === this.$route.params.masterplanId
    //   )
    //   if (item) this.tab = item.tab
    // }
  },
  async mounted() {
    this.nestedMasterplansLicenseDisabled()
    await this.getData(this.$route.params.masterplanId)
    let lastBreadcrumb = this.$store.state.BreadcrumbsStore.history[
      this.$store.state.BreadcrumbsStore.history.length - 1
    ]
    if (lastBreadcrumb && lastBreadcrumb.tab) {
      if (lastBreadcrumb.tab === 'BUILDING ') {
        this.tab = 'buildings'
      }
      if (
        lastBreadcrumb.text === 'MASTERPLAN ' &&
        lastBreadcrumb.tab === 'COMMUNITY '
      ) {
        this.tab = 'masterplans'
      }
      if (
        lastBreadcrumb.text === 'MASTERPLAN ' &&
        lastBreadcrumb.tab === 'MASTERPLAN '
      ) {
        this.tab = 'masterplans'
      }
      if (lastBreadcrumb.tab === 'P.O.I ') {
        this.tab = 'pois'
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    next(async vm => {
      await vm.$store.dispatch('MediaStore/resetStore')
    })
  },
  async beforeRouteUpdate(to, from, next) {
    await this.confirmLeaveMediaGalleryIfDirty()
    await this.$store.dispatch('MediaStore/resetStore')
    // this.getData(to.params.masterplanId)
    // if (!localStorage.exploreMasterplanActiveTabs) {
    //   localStorage.exploreMasterplanActiveTabs = JSON.stringify([
    //     {
    //       tab: this.tab,
    //       mid: from.params.masterplanId
    //     }
    //   ])
    // } else {
    //   var temp = JSON.parse(localStorage.exploreMasterplanActiveTabs)
    //   var foundIndex = temp.findIndex(
    //     element => element.mid == this.$route.params.masterplanId
    //   )
    //   if (foundIndex !== -1) {
    //     temp[foundIndex].tab = this.tab
    //   } else {
    //     temp.push({
    //       tab: this.tab,
    //       mid: from.params.masterplanId
    //     })
    //   }
    //
    //   localStorage.exploreMasterplanActiveTabs = JSON.stringify(temp)
    // }
    next()
  },
  async beforeRouteLeave(to, from, next) {
    await this.confirmLeaveMediaGalleryIfDirty()
    // if (
    //   to.name == 'Explore Poi' ||
    //   to.name == 'Explore Masterplan' ||
    //   to.name == 'Explore Building'
    // ) {
    //   if (!localStorage.exploreMasterplanActiveTabs) {
    //     localStorage.exploreMasterplanActiveTabs = JSON.stringify([
    //       {
    //         tab: this.tab,
    //         mid: from.params.masterplanId
    //       }
    //     ])
    //   } else {
    //     let temp = JSON.parse(localStorage.exploreMasterplanActiveTabs)
    //     var foundIndex = temp.findIndex(
    //       element => element.mid == this.$route.params.masterplanId
    //     )
    //     if (foundIndex !== -1) {
    //       temp[foundIndex].tab = this.tab
    //     } else {
    //       temp.push({
    //         tab: this.tab,
    //         mid: from.params.masterplanId
    //       })
    //     }
    //
    //     localStorage.exploreMasterplanActiveTabs = JSON.stringify(temp)
    //   }
    // } else {
    //   if (localStorage.exploreMasterplanActiveTabs) {
    //     let temp = JSON.parse(localStorage.exploreMasterplanActiveTabs)
    //     temp = temp.filter(function(value, index, arr) {
    //       if (value.mid == to.params.masterplanId) return true
    //     })
    //     localStorage.exploreMasterplanActiveTabs = JSON.stringify(temp)
    //   }
    // }
    next()
  }
}
</script>

<style lang="scss">
.v-window__container {
  height: 100%;
  .full-height-card {
    height: 100%;
    display: flex;
    flex-direction: column;
  }
}
.checkboxButton {
  opacity: 1 !important;
  pointer-events: all !important;
}
</style>
